import React from "react";
import SubBanner from "./components/SubBanner";
import Follow from "./components/Follow";

function Nuts() {
  return (
    <>
      <SubBanner title="Nuts" />

      <section className="shop1-con prod position-relative">
        <div className="container-fluid p-5">

          <div className="row shop-products-con">
            <ProductCard
              image="../assets/product-images/Pistachio.png"
              name="Pistachio"
              desc="A rich and creamy scoop packed with the royal taste of roasted pistachios."
            />

            <ProductCard
              image="../assets/product-images/Hazlenut.png"
              name="Hazelnut"
              desc="Smooth, nutty indulgence with the comforting flavour of premium hazelnuts."
            />

            <ProductCard
              image="../assets/product-images/Cashew.png"
              name="Cashew"
              desc="Silky gelato blended with the naturally buttery goodness of cashews."
            />

            <ProductCard
              image="../assets/product-images/almond.png"
              name="Almond"
              desc="A delicately nutty delight with the wholesome richness of almonds."
            />
          </div>

          <div className="row shop-products-con mt-3">
            <ProductCard
              image="../assets/product-images/Peanut Butter.png"
              name="Peanut Butter"
              desc="Creamy, bold, and irresistibly nutty with a perfectly smooth finish."
            />
          </div>

        </div>
      </section>

      <Follow />
    </>
  );
}

// Product Card
function ProductCard({ image, name, desc }) {
  return (
    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
      <div className="classic-box hover-card">
        <div className="classic_image_box box1">
          <img src={image} alt={name} />
        </div>

        <div className="hover-content">
          <h6 className="hover-title">{name}</h6>
          <p className="hover-desc">{desc}</p>
        </div>
      </div>
    </div>
  );
}

export default Nuts;